/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resources_BookableInputs */

const en_admin_resources_bookable = /** @type {(inputs: Admin_Resources_BookableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bookable`)
};

const de_admin_resources_bookable = /** @type {(inputs: Admin_Resources_BookableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buchbar`)
};

const es_admin_resources_bookable = /** @type {(inputs: Admin_Resources_BookableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reservable`)
};

const fr_admin_resources_bookable = /** @type {(inputs: Admin_Resources_BookableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réservable`)
};

const nl_admin_resources_bookable = /** @type {(inputs: Admin_Resources_BookableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reserveerbaar`)
};

/** @type {(inputs: Admin_Resources_BookableInputs) => LocalizedString} */
const it_admin_resources_bookable = en_admin_resources_bookable;

/** @type {(inputs: Admin_Resources_BookableInputs) => LocalizedString} */
const pt_br2_admin_resources_bookable = en_admin_resources_bookable;

/** @type {(inputs: Admin_Resources_BookableInputs) => LocalizedString} */
const pl_admin_resources_bookable = en_admin_resources_bookable;

/** @type {(inputs: Admin_Resources_BookableInputs) => LocalizedString} */
const hu_admin_resources_bookable = en_admin_resources_bookable;

/** @type {(inputs: Admin_Resources_BookableInputs) => LocalizedString} */
const ro_admin_resources_bookable = en_admin_resources_bookable;

/**
* | output |
* | --- |
* | "Bookable" |
*
* @param {Admin_Resources_BookableInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resources_bookable = /** @type {((inputs?: Admin_Resources_BookableInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resources_BookableInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resources_bookable(inputs)
	if (locale === "de") return de_admin_resources_bookable(inputs)
	if (locale === "es") return es_admin_resources_bookable(inputs)
	if (locale === "fr") return fr_admin_resources_bookable(inputs)
	if (locale === "nl") return nl_admin_resources_bookable(inputs)
	if (locale === "it") return it_admin_resources_bookable(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resources_bookable(inputs)
	if (locale === "pl") return pl_admin_resources_bookable(inputs)
	if (locale === "hu") return hu_admin_resources_bookable(inputs)
	return ro_admin_resources_bookable(inputs)
});
export { admin_resources_bookable as "admin.resources.bookable" }